/**
 * @generated SignedSource<<497bbcfce8667f649dde42a4d193a193>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type InitializeVirtualizer_issueResults$data = {
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraIssueEdge";
    readonly node: {
      readonly issueId?: string;
      readonly key: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "InitializeVirtualizer_issueResults";
};
export type InitializeVirtualizer_issueResults$key = {
  readonly " $data"?: InitializeVirtualizer_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"InitializeVirtualizer_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "InitializeVirtualizer_issueResults",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "issueId"
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "e2ef750f586d3a504b812ff1d64e52a4";

export default node;
